module.exports = __webpack_public_path__ + "images/speed-three-default.3f800613343c7ab1ec6623f38d8e7766.png";